import { Asset, AssetType, bytesToSize } from "@thenounproject/lingo-core";
import { getHexStringFromAsset } from "./getHexStringFromAsset";

type AssetFileDetailsConfig = {
  showColorValue?: boolean;
};

export default function assetFileDetails(asset: Asset, config?: AssetFileDetailsConfig) {
  const isColor = asset.type === AssetType.color;
  const isFont = asset.type === AssetType.textStyle;
  const isLink = asset.type === AssetType.URL;

  if (isColor) {
    let val = "Color";
    if (config?.showColorValue) {
      val += ` • ${getHexStringFromAsset(asset)}`;
    }
    return val;
  }

  if (isLink) {
    return `URL${asset.meta.content.fld ? ` • ${asset.meta.content.fld}` : ""}`;
  }

  const formattedSize = bytesToSize(asset.size);
  if (isFont) {
    const fontName = asset.meta.font.displayName || "Font";
    const ext = asset.meta.font.extension?.toUpperCase() || "Font";
    const base = `${ext} • ${fontName}`;
    return base;
  }

  const type = AssetType.displayName(asset.type);
  if ([...AssetType.imageTypes, ...AssetType.sketchTypes].includes(asset.type)) {
    return `${type} • ${asset.dimensions}`;
  }

  return `${type} • ${formattedSize}`;
}
